import { Node } from '@tiptap/core';
var Text = Node.create({
  name: 'text',
  group: 'inline'
});
export { Text, Text as default };